import React from "react";

import Image from "next/image";
import { useMutation } from "@apollo/client";
import Link from "next/link";
import { Icon } from "@/components/icon";
import { useFavListingsState } from "@/contexts/fav-listings/favListings.provider";
import {
  addImgReportedID,
  CloudfrontImageLoader,
  getStoredImgsReportedIDs,
} from "@/lib/helpers";
import { REPORT_IMAGES_ISSUE } from "@/graphql/mutations/report";
import { useAuthState } from "@/contexts/auth/auth.provider";
import css from "./.module.scss";
import { usePath } from "@/contexts/path/path";

export const getImageSrc = (images) =>
  Array.isArray(images) && images[0] ? images[0] : "";
export default function NativeListingCard({ listing, preloadImage }) {
  const {
    logo,
    title,
    image,
    external_url: externalUrl,
    description,
  } = listing.native;
  const isFavorite = useFavListingsState(listing.id);

  const token = useAuthState("token");

  const [reportImagesIssue] = useMutation(REPORT_IMAGES_ISSUE, {
    context: { token },
  });
  const { updateContext } = usePath();

  return (
    <div className={css.link}>
      <Link
        href={{
          pathname: externalUrl || listing.path,
        }}
        target={externalUrl ? "_blank" : undefined}
        rel="noreferrer"
        shallow
        className={css.listingCard}
      >
        <div
          onClick={() => {
            if (externalUrl) return;

            updateContext({ listing });
          }}
          className={css.listingCard}
        >
          {isFavorite && (
            <div className={css.fav}>
              <button type="button">
                <Icon
                  className={css.icon}
                  name="BorderHeart"
                  color="colored"
                  alt="مفضلة"
                />
              </button>
            </div>
          )}
          <div className={css.content}>
            <h4>{title}</h4>

            <div className={css.ad}>إعلان</div>

            <div className={css.description}>
              <p>{description}</p>
              {logo ? (
                <div className={css.logo}>
                  <Image
                    unoptimized
                    src={`https://images.aqar.fm/webp/120x0/native-listings-logos/${logo}`}
                    alt={title}
                    fill
                  />
                </div>
              ) : null}
            </div>
          </div>
          <div className={css.imageWrapper}>
            <Image
              loader={CloudfrontImageLoader}
              src={image || getImageSrc(listing.imgs) || "villa-default.png"}
              onError={() => {
                const reportedImgs = getStoredImgsReportedIDs();
                if (!(reportedImgs && reportedImgs[image]) && token) {
                  addImgReportedID(image);
                  reportImagesIssue({
                    variables: {
                      listing_id: listing.id,
                      images: image,
                    },
                  });
                }
              }}
              fill
              alt={title || ""}
              sizes="(max-width: 600px) 40vw, 100vw"
              priority={preloadImage}
            />
          </div>
        </div>
      </Link>
    </div>
  );
}
